import { Tile } from '../../tiles/index.js'

const SUITS = [
  ['MAN', ['1m', '2m', '3m', '4m', '5m', '6m', '7m', '8m', '9m']],
  ['PIN', ['1p', '2p', '3p', '4p', '5p', '6p', '7p', '8p', '9p']],
  ['SOU', ['1s', '2s', '3s', '4s', '5s', '6s', '7s', '8s', '9s']],
  ['HON', ['1z', '2z', '3z', '4z', '5z', '6z', '7z']],
  ['AKA', ['0m', '0p', '0s', 'xx']],
]

const LABELS = { remove: 'Removes', mark: 'Marks', rotate: 'Rotates' }

const SEPARATOR = {
  letterSpacing: 1,
  color: 'var(--color-neutral-500)',
}

const segOn = {
  cursor: 'pointer',
  padding: '3px 9px',
  border: '1px solid var(--color-accent)',
  background: 'var(--color-accent)',
  color: '#fff',
  fontWeight: 600,
}

const segOff = {
  cursor: 'pointer',
  padding: '3px 9px',
  border: '1px solid var(--color-neutral-400)',
  background: '#fff',
  color: 'var(--color-neutral-700)',
}

export default function TilePalette({ mode, onMode, onAdd }) {
  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 7 }}>
      <div style={{ fontFamily: 'var(--font-heading)', fontSize: 10, letterSpacing: 3, color: 'var(--color-neutral-600)' }}>
        TILE PALETTE · CLICK TO ADD
      </div>
      <div style={{ display: 'flex', gap: 6, fontSize: 10, alignItems: 'center' }}>
        <span style={SEPARATOR}>CANVAS CLICK</span>
        {['remove', 'mark', 'rotate'].map((m) => (
          <span key={m} onClick={() => onMode(m)} style={m === mode ? segOn : segOff}>
            {LABELS[m]}
          </span>
        ))}
      </div>
      {SUITS.map((row) => (
        <div key={row[0]} style={{ display: 'flex', gap: 2, alignItems: 'center' }}>
          <span
            style={{
              width: 34,
              fontFamily: 'var(--font-heading)',
              fontSize: 8.5,
              letterSpacing: 1,
              color: 'var(--color-neutral-500)',
            }}
          >
            {row[0]}
          </span>
          {row[1].map((code) => (
            <span key={code} onClick={() => onAdd(code)} style={{ cursor: 'pointer' }}>
              <Tile code={code} width={22} />
            </span>
          ))}
        </div>
      ))}
    </div>
  )
}
